import { handleFetchResponse } from '@noths/polaris-client-utils';
import type { Product } from '@noths/polaris-dev-ts-types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import fetch from 'isomorphic-fetch';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types';
const { publicRuntimeConfig } = getConfig() as NextConfig;

export const elevaateProductImpressions = createAsyncThunk(
  'products/elevaateProductImpressions',
  async ({ products }: { products: Product[] }) => {
    let elevaatePageImpressionId = '';

    const sponsoredProductsQueryString = products.reduce((acc, item) => {
      if (!item.sponsoredProductData) {
        return acc;
      }

      const { sponsoredProductData } = item;
      const sponsoredProductQueryString = encodeURIComponent(
        `${sponsoredProductData['data-elevaate-aid']}|${sponsoredProductData['data-elevaate-pid']}`,
      );

      if (acc === '') {
        elevaatePageImpressionId = sponsoredProductData['data-elevaate-piid'];

        return acc.concat(sponsoredProductQueryString);
      }

      return acc.concat(`,${sponsoredProductQueryString}`);
    }, '');

    if (sponsoredProductsQueryString.length > 0) {
      const elevaateImpressionsUrlFragment = `${elevaatePageImpressionId}/renderPageCharge.json?prms=${sponsoredProductsQueryString}`;
      const elevaateImpressionsUrl = `${publicRuntimeConfig.endpoints.elevaateImpressions}/${publicRuntimeConfig.ELEVAATE_API_KEY}/${elevaateImpressionsUrlFragment}`;

      await fetch(elevaateImpressionsUrl)
        .then(handleFetchResponse)
        .then((data) => {
          console.log(`Registered impressions for: ${elevaateImpressionsUrlFragment}.`, data);
        });
    }
  },
);
